import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { enqueueSnackbar } from 'actions';
import { CardHeader, CardContent, Divider, Card, Alert } from '@mui/material';
import { FilesDropzone } from 'components';

import ModalDialog from '../../../../../components/ModalDialog/ModalDialog.js';

import { UploadCustomLayerFiles } from '../../../actions/DualMapActions';

const CustomLayerDialog = (props) => {
	const { open, onClose, ...rest } = props;
	const dispatch = useDispatch();
	const userId = useSelector(state => state.session.user.id);

	const _onFilesUpload = files => {
		let totalSize = 0;
		const allowedFormats = ['.dat', '.map', '.tab', '.id'];
		let mapInfoFiles = [];

		files.forEach(file => {
			totalSize += file.size;
			const fileNameWithoutExtension = file.name.slice(0, file.name.lastIndexOf('.'));
			const fileExtension = file.name.slice(file.name.lastIndexOf('.'));
			// if its a map info file
			if (allowedFormats.includes(fileExtension)) {
				if (mapInfoFiles === []) {
					mapInfoFiles = [{ name: fileNameWithoutExtension, count: 1 }];
				} else if (mapInfoFiles.some(object => object.name === fileNameWithoutExtension)) {
					mapInfoFiles.find(object => object.name === fileNameWithoutExtension).count++;
				} else {
					mapInfoFiles.push({ name: fileNameWithoutExtension, count: 1 });
				}
			}
		});
		if (totalSize > 100000000) {
			dispatch(
				enqueueSnackbar({
					message: 'Files not valid. Please check files size.',
					options: { variant: 'warning' }
				})
			);
		} else if (mapInfoFiles !== [] && mapInfoFiles.some(object => object.count < 4)) {
			dispatch(
				enqueueSnackbar({
					message: 'Files not valid. Please check if map info files are all selected.',
					options: { variant: 'warning' }
				})
			);
		} else {
			dispatch(UploadCustomLayerFiles(files, userId));
		}
	};

	return (
		<ModalDialog
			maxWidth="md"
			onClose={onClose}
			open={open}
			title="Custom Layer"
			hasConfirm={false}
			cancelLabel="Close"
		>
			<FilesDropzone acceptedTypes=".geojson,.dat,.map,.tab,.id" upload={_onFilesUpload} />
		</ModalDialog>

	);
};

CustomLayerDialog.propTypes = {
	onClose: PropTypes.func,
	open: PropTypes.bool.isRequired,
};

export default CustomLayerDialog;
